export const CompletedItem = {
    mainText: 'stepperOnboarding.home.firstSteps.completedSteps.congrats',
    description: 'stepperOnboarding.home.firstSteps.completedSteps.text',
};
